function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { DateTime, Duration } from 'luxon';
import { LatLng } from 'leaflet';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarcode, faPlus } from '@fortawesome/free-solid-svg-icons';
import Venue from '../../../../model/Venue';
import './VenueSelector.css';

var VenueSelector = /*#__PURE__*/function (_React$Component) {
  _inherits(VenueSelector, _React$Component);

  function VenueSelector(props) {
    var _this;

    _classCallCheck(this, VenueSelector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VenueSelector).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "selectVenue", function (e, venue) {
      var _this$props = _this.props,
          logBookEntry = _this$props.logBookEntry,
          onSelect = _this$props.onSelect;
      logBookEntry.venue = venue;
      onSelect(e, logBookEntry);
    });

    _this.state = {
      venues: []
    };
    return _this;
  }

  _createClass(VenueSelector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var storage = this.props.storage;
      Venue.all(storage).then(function (venues) {
        if (window.cordova) {
          BackgroundGeolocation.getCurrentLocation(function (position) {
            var location = new LatLng(position.latitude, position.longitude);
            var nearbyVenues = venues.filter(function (venue) {
              return venue.position.distanceTo(location) <= 160934;
            }); // 100 miles

            _this2.setState({
              venues: nearbyVenues
            });
          }, function (err) {
            return console.error(err);
          });
        } else {
          navigator.geolocation.getCurrentPosition(function (position) {
            var location = new LatLng(position.coords.latitude, position.coords.longitude);
            var nearbyVenues = venues.filter(function (venue) {
              return venue.position.distanceTo(location) <= 160934;
            }); // 100 miles

            _this2.setState({
              venues: nearbyVenues
            });
          }, function (err) {
            return console.error(err);
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var selectVenue = this.selectVenue;
      var _this$props2 = this.props,
          app = _this$props2.app,
          width = _this$props2.width,
          height = _this$props2.height,
          logBookEntry = _this$props2.logBookEntry,
          onSelect = _this$props2.onSelect;
      var venues = this.state.venues;
      return React.createElement("div", {
        className: "venue-selector",
        style: {
          height: "".concat(height, "px")
        }
      }, React.createElement("div", {
        className: "venues",
        style: {
          height: "".concat(height - 50, "px")
        }
      }, venues.length === 0 && React.createElement("div", {
        className: "venue no-venues-found",
        key: 'no-venues-found',
        onClick: onSelect
      }, React.createElement("div", {
        className: "name"
      }, "no venues found nearby")), venues.map(function (venue) {
        return React.createElement("div", {
          className: "venue ripple ".concat(venue.id === logBookEntry.venue.id ? 'selected' : ''),
          key: venue.id.toString(),
          onClick: function onClick(e) {
            return selectVenue(e, venue);
          }
        }, React.createElement("div", {
          className: "name"
        }, venue.name), React.createElement("div", {
          className: "location"
        }, "".concat(venue.city, ", ").concat(venue.state)));
      })));
    }
  }]);

  return VenueSelector;
}(React.Component);

export default VenueSelector;